import { useEffect } from "react";
import { WorldFilled } from "../../../components/OldDesign/Icons";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { MY_NETWORK_TABS } from "../../../components/NewDesign/constants";
import { useTranslation } from "react-i18next";
import AddProfileButton from "components/NewDesign/Button/AddProfileButton";
import AddPeopleButton from "components/NewDesign/Button/AddPeopleButton";

const MyNetwork = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const myNetworkTabs = MY_NETWORK_TABS();
  const isModalOpenFromState = location.state?.isModalOpen || false;

  useEffect(() => {
    if (isModalOpenFromState) {
      navigate("/invite", {
        state: { previousLocation: location },
      });
    }
  }, [isModalOpenFromState, navigate]);
  return (
    <main className="bg-neutral-200 max-lg:bg-neutral-100 max-lg:pt-[53px]">
      {/* Lists */}
      <div className="container2 py-6 max-lg:py-3" id="mynetwork">
        <div className="rounded-xl bg-neutral-100 p-9 max-lg:p-0">
          {/* ACTIONS */}
          <div className="flex flex-row items-center justify-between pb-1">
            <div className="flex items-baseline gap-3 max-lg:gap-1">
              <WorldFilled className="h-7 w-7 max-lg:h-4 max-lg:w-4" />
              <h3 className="text-[32px] font-bold leading-tight text-primary-900 max-lg:text-[18px]">
                {t("header.nav_links.mynetwork")}
              </h3>
            </div>
            <div className="flex items-center gap-2 max-lg:gap-1">
              <AddProfileButton />
              <AddPeopleButton />
            </div>
          </div>
          <ul className="scrollbar-hide mb-2 flex items-center justify-start gap-6 overflow-x-scroll border-b-2 ">
            {myNetworkTabs.map((tab, idx) => (
              <MyNetworkTab key={idx} tab={tab} />
            ))}
          </ul>
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </main>
  );
};
const MyNetworkTab = ({ tab }) => {
  return (
    <NavLink
      to={tab.path}
      style={({ isActive, isPending }) => {
        return {
          color: isActive ? "#4D5AA6" : "#C2C2D6",
          borderColor: isActive ? "#4D5AA6" : "",
          borderBottom: isActive ? "2px solid #4D5AA6" : "",
          borderRadius: 2,
        };
      }}
      className="whitespace-nowrap pb-3 text-[18px] font-bold leading-tight max-lg:pb-1 max-lg:text-[15px]"
    >
      {tab.title}
    </NavLink>
  );
};

export default MyNetwork;
